import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getSpeciality } from "../../Redux/Slice/SpecialitySlice";

// Emoji icons for each specialization
const iconMap = {
  Cardiology: "❤️",
  Dermatology: "🧴",
  Dental: "🦷",
  Dentel: "🦷",
  "Ent surgeon": "👂",
  Heamotology: "🩸",
  Neurology: "🧠",
  Pediatrics: "🧒",
  Oncology: "🧬",
  Anesthesia: "💉",
  "Plastic Surgery": "🧪",
  default: "🩺",
};

// Background colors (will loop)
const bgColors = ["#E6F7F1", "#FCE8F0", "#FFF8E5", "#E6EDFF"];

const Specializations = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showAll, setShowAll] = useState(false);
  const [isNarrowScreen, setIsNarrowScreen] = useState(
    window.innerWidth < 1540
  );

  const { items } = useSelector((state) => state.speciality);
  const specializations = items?.data || [];

  useEffect(() => {
    dispatch(getSpeciality());
  }, [dispatch]);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => setIsNarrowScreen(window.innerWidth < 1540);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Show limited number of cards depending on screen size
  const displayList = showAll
    ? specializations
    : specializations.slice(0, isNarrowScreen ? 5 : 8);

  const handleSpecializationClick = (specialityName) => {
    navigate(`/speciality/${specialityName}`);
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.title}>Specializations</div>
        <button style={styles.toggleBtn} onClick={() => setShowAll(!showAll)}>
          {showAll ? "Hide" : "See All"}
        </button>
      </div>

      {/* Grid */}
      <div
        style={{
          ...styles.grid,
          justifyContent: showAll ? "flex-start" : "center",
        }}
      >
        {displayList.map((item, index) => {
          const icon =
            iconMap[item.specialityName?.trim()] ||
            iconMap[item.specialityName?.toLowerCase()] ||
            iconMap.default;
          const bg = bgColors[index % bgColors.length];

          // console.log("item", item);

          return (
            <div
              key={item.specialityName}
              style={{ ...styles.card, backgroundColor: bg }}
              onClick={() => handleSpecializationClick(item.specialityName)}
            >
              <div style={styles.icon}>{icon}</div>
              <div style={styles.name}>{item.specialityName}</div>
              {/* <div style={styles.hospital}>
                {item.hospitalName || item.branchName || "N/A"}
              </div> */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

// --- Styles ---
const styles = {
  container: {
    padding: "2rem",
    backgroundColor: "#f9fafc",
    fontFamily: "Roboto, sans-serif",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1.5rem",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    color: "#2f3c7e",
  },
  toggleBtn: {
    background: "#3f8efc",
    color: "#fff",
    border: "none",
    borderRadius: "20px",
    padding: "0.4rem 1.2rem",
    fontSize: "0.9rem",
    cursor: "pointer",
    transition: "0.2s ease",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "1rem",
  },
  card: {
    borderRadius: "12px",
    padding: "1.5rem 1rem",
    textAlign: "center",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    transition: "all 0.2s ease",
  },
  icon: {
    fontSize: "2rem",
    marginBottom: "0.8rem",
  },
  name: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#333",
  },
  hospital: {
    fontSize: "0.85rem",
    color: "#666",
    marginTop: "0.3rem",
  },
};

export default Specializations;
